import mitt from 'mitt';

const emitter = mitt();

function safeEmit(type, event) {
  const handlers = emitter.all.get(type);
  if (handlers) {
    handlers
      .slice()
      .filter(h => typeof h === 'function')
      .forEach(h => h(event));
  }
  const wildcard = emitter.all.get('*');
  if (wildcard) {
    wildcard
      .slice()
      .filter(h => typeof h === 'function')
      .forEach(h => h(type, event));
  }
}

emitter.$on = emitter.on;
emitter.$off = emitter.off;
emitter.emit = safeEmit;
emitter.$emit = safeEmit;

/**
 * Returns the singleton event hub instance for application-wide event communication.
 * @returns {EventHub} The event hub singleton instance
 */
export function useEventHub() {
  return emitter;
}

/**
 * @template {Record<string, unknown>} TEventMap
 * @typedef {import('mitt').Emitter<TEventMap>} Emitter
 */

/**
 * @typedef {Object} EventHub
 * @property {Emitter['on']} on - Subscribe to an event
 * @property {Emitter['on']} $on - Alias for `on`
 * @property {Emitter['off']} off - Unsubscribe from an event
 * @property {Emitter['off']} $off - Alias for `off`
 * @property {Emitter['emit']} emit - Emit an event
 * @property {Emitter['emit']} $emit - Alias for `emit`
 * @property {Emitter['all']} all - Event handler map
 */
